import { axiosInstance } from '@mgk-eld/utils';

const oauthApi = {
  // Authorize client with scopes
  authorize: (data: {
    client_id: string;
    redirect_uri: string;
    scopes: string[];
  }) => {
    return axiosInstance.post('/oauth2/authorize', data);
  },
};

export default oauthApi;
